import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cn } from "../../lib/cn";

const DialogBody = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("overflow-auto px-7", className)} {...props}>
        {children}
      </div>
    );
  },
);

DialogBody.displayName = "DialogBody";

export { DialogBody };
